export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwoEars_yg.101df52d.jpg";